var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcXWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08002 6.07709C6.40545 5.75165 6.93309 5.75165 7.25853 6.07709L10.0026 8.82116L12.7467 6.07709C13.0721 5.75165 13.5998 5.75165 13.9252 6.07709C14.2506 6.40252 14.2506 6.93016 13.9252 7.2556L11.1811 9.99967L13.9252 12.7438C14.2506 13.0692 14.2506 13.5968 13.9252 13.9223C13.5998 14.2477 13.0721 14.2477 12.7467 13.9223L10.0026 11.1782L7.25853 13.9223C6.93309 14.2477 6.40545 14.2477 6.08002 13.9223C5.75458 13.5968 5.75458 13.0692 6.08002 12.7438L8.82409 9.99967L6.08002 7.2556C5.75458 6.93016 5.75458 6.40252 6.08002 6.07709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXWhite);
export default __webpack_public_path__ + "static/media/ic-x-white.fc614406553d53a5b0aa99510ff83b2b.svg";
export { ForwardRef as ReactComponent };